export function initialState() {
  return {
    mainSectionPosition: {
      left: 200,
      top: 150,
      width: window.innerWidth - 230,
      height: window.innerHeight - 280,
    },
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
  }
}

export default initialState()
